<div class="chat-header">
  <div class="header-left">
    <div class="header-avatar">
      @if (chat().type === 'GROUP') {
        <div class="avatar group-avatar">
          <span class="material-symbols-outlined">group</span>
        </div>
      } @else {
        <app-profile-pic [name]="displayName" />
      }
    </div>

    <div
      class="header-info"
      (click)="onGroupNameClick()"
    >
      <span class="header-name">{{ displayName }}</span>
      @if (chat().type === 'GROUP') {
        <span class="header-participants">{{ participantsSummary }}</span>
      }
    </div>
  </div>

  <div class="header-right">
    @if (chat().type === 'PRIVATE' && isOnline) {
      <span class="online-label">{{ translateService.getTranslation(4152) }}</span>
      <span class="online-indicator"></span>
    }
    @if (chat().type === 'GROUP') {
      <button class="edit-group-btn" (click)="editGroupClicked.emit()">
        <span class="material-symbols-outlined">edit</span>
      </button>
      <span class="participants-text">{{ participantsSummary }}</span>
    }
  </div>
</div>
